import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableEpocusConsentDocumentFragment = { readonly __typename?: 'SyncableEpocusConsentDocument', readonly id: string, readonly version: number, readonly items: ReadonlyArray<{ readonly __typename?: 'EpocusConsentItem', readonly id: string, readonly audience: Types.EpocusConsentAudience, readonly kind: Types.EpocusConsentItemKind, readonly ordinal: number, readonly bodyText: string }>, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncEpocusConsentDocumentPullQueryVariables = Types.Exact<{
  input: Types.PullEpocusConsentDocumentInput;
}>;


export type SyncEpocusConsentDocumentPullQuery = { readonly __typename?: 'Query', readonly pullEpocusConsentDocument: { readonly __typename?: 'PullEpocusConsentDocumentResponse', readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusConsentDocument', readonly id: string, readonly version: number, readonly items: ReadonlyArray<{ readonly __typename?: 'EpocusConsentItem', readonly id: string, readonly audience: Types.EpocusConsentAudience, readonly kind: Types.EpocusConsentItemKind, readonly ordinal: number, readonly bodyText: string }>, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableEpocusConsentDocumentFragmentDoc = gql`
    fragment WholeSyncableEpocusConsentDocument on SyncableEpocusConsentDocument {
  id
  version
  items {
    id
    audience
    kind
    ordinal
    bodyText
  }
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncEpocusConsentDocumentPullDocument = gql`
    query SyncEpocusConsentDocumentPull($input: PullEpocusConsentDocumentInput!) {
  pullEpocusConsentDocument(input: $input) {
    documents {
      ...WholeSyncableEpocusConsentDocument
    }
  }
}
    ${WholeSyncableEpocusConsentDocumentFragmentDoc}`;

/**
 * __useSyncEpocusConsentDocumentPullQuery__
 *
 * To run a query within a React component, call `useSyncEpocusConsentDocumentPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusConsentDocumentPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncEpocusConsentDocumentPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusConsentDocumentPullQuery(baseOptions: Apollo.QueryHookOptions<SyncEpocusConsentDocumentPullQuery, SyncEpocusConsentDocumentPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncEpocusConsentDocumentPullQuery, SyncEpocusConsentDocumentPullQueryVariables>(SyncEpocusConsentDocumentPullDocument, options);
      }
export function useSyncEpocusConsentDocumentPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncEpocusConsentDocumentPullQuery, SyncEpocusConsentDocumentPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncEpocusConsentDocumentPullQuery, SyncEpocusConsentDocumentPullQueryVariables>(SyncEpocusConsentDocumentPullDocument, options);
        }
export type SyncEpocusConsentDocumentPullQueryHookResult = ReturnType<typeof useSyncEpocusConsentDocumentPullQuery>;
export type SyncEpocusConsentDocumentPullLazyQueryHookResult = ReturnType<typeof useSyncEpocusConsentDocumentPullLazyQuery>;
export type SyncEpocusConsentDocumentPullQueryResult = Apollo.QueryResult<SyncEpocusConsentDocumentPullQuery, SyncEpocusConsentDocumentPullQueryVariables>;